import { render } from "./EmergencyAnswerAttachmentModal.vue?vue&type=template&id=44954809&scoped=true&ts=true"
import script from "./EmergencyAnswerAttachmentModal.ts?vue&type=script&lang=ts"
export * from "./EmergencyAnswerAttachmentModal.ts?vue&type=script&lang=ts"

import "./EmergencyAnswerAttachmentModal.scss?vue&type=style&index=0&id=44954809&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44954809"]])

export default __exports__